'use client';

import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

export default function BootstrapClient() {
  useEffect(() => {
    require('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, []);

  return <>
    <Toaster />
  </>;
}